import { Reveal } from "@/components/Reveal";
import { AccentTitle } from "@/components/AccentTitle";

export const SectionHeading = ({ title, sub, light = false, id, accent, children }) => (
  <Reveal className="max-w-[720px]">
    <h2 id={id} data-testid={`${id}-heading`} className={`${accent ? "font-serif font-bold " : ""}${light ? "text-white" : ""}`.trim() || undefined}>
      {accent ? <AccentTitle title={title} accent={accent} /> : title}
    </h2>
    {sub && <p className={`sub-line mt-4 ${light ? "text-white/80" : "text-body"}`}>{sub}</p>}
    {children}
  </Reveal>
);
